<template>
    <form
        @submit.prevent="form.post(route('checkout.step.form.store'))"
        class="bg-white p-4 rounded-2xl shadow-lg"
    >
        <div class="mb-5 font-semibold text-xl text-primary-text">
            Personenbezogene Daten
        </div>

        <div class="grid sm:grid-cols-2 gap-x-10 gap-y-5 sm:space-y-0">
            <div>
                <label for="company" class="block text-primary-text">
                    Firma
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.company"
                        name="company"
                        id="company"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.company,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.company">
                    <strong>{{ form.errors.company }}</strong>
                </small>
            </div>

            <div>
                <label for="firstname" class="block text-primary-text">
                    Vorname
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.firstname"
                        name="firstname"
                        id="firstname"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.firstname,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.firstname">
                    <strong>{{ form.errors.firstname }}</strong>
                </small>
            </div>

            <div>
                <label for="lastname" class="block text-primary-text">
                    Nachname
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.lastname"
                        name="lastname"
                        id="lastname"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.lastname,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.lastname">
                    <strong>{{ form.errors.lastname }}</strong>
                </small>
            </div>

            <div>
                <label for="street" class="block text-primary-text">
                    Straße und Hausnummer
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.street"
                        name="street"
                        id="street"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.street,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.street">
                    <strong>{{ form.errors.street }}</strong>
                </small>
            </div>

            <div>
                <label for="zip" class="block text-primary-text"> PLZ </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.zip"
                        name="zip"
                        id="zip"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.zip,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.zip">
                    <strong>{{ form.errors.zip }}</strong>
                </small>
            </div>

            <div>
                <label for="city" class="block text-primary-text">
                    Stadt
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.city"
                        name="city"
                        id="city"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.city,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.city">
                    <strong>{{ form.errors.city }}</strong>
                </small>
            </div>

            <div>
                <label for="email" class="block text-primary-text">
                    E-Mail-Adresse
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="email"
                        v-model="form.email"
                        name="email"
                        id="email"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.email,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.email">
                    <strong>{{ form.errors.email }}</strong>
                </small>
            </div>

            <div>
                <label for="phone" class="block text-primary-text">
                    Telefon
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.phone"
                        name="phone"
                        id="phone"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.phone,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.phone">
                    <strong>{{ form.errors.phone }}</strong>
                </small>
            </div>

            <div>
                <label for="date_of_birth" class="block text-primary-text">
                    Geburtsdatum
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.date_of_birth"
                        name="date_of_birth"
                        id="date_of_birth"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.date_of_birth,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.date_of_birth">
                    <strong>{{ form.errors.date_of_birth }}</strong>
                </small>
            </div>

            <div>
                <label for="place_of_birth" class="block text-primary-text">
                    Geburtsort
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.place_of_birth"
                        name="place_of_birth"
                        id="place_of_birth"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.place_of_birth,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.place_of_birth">
                    <strong>{{ form.errors.place_of_birth }}</strong>
                </small>
            </div>

            <div>
                <label for="drivers_license_id" class="block text-primary-text">
                    Führerscheinnummer
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers_license_id"
                        name="drivers_license_id"
                        id="drivers_license_id"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors.drivers_license_id,
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors.drivers_license_id"
                >
                    <strong>{{ form.errors.drivers_license_id }}</strong>
                </small>
            </div>

            <div>
                <label for="identity_card_id" class="block text-primary-text">
                    Ausweisnummer
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.identity_card_id"
                        name="identity_card_id"
                        id="identity_card_id"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors.identity_card_id,
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors.identity_card_id">
                    <strong>{{ form.errors.identity_card_id }}</strong>
                </small>
            </div>
        </div>

        <div class="my-5">
            <div class="relative flex items-center">
                <div class="flex items-center h-5">
                    <input
                        v-model="form.second_driver"
                        id="second_driver"
                        name="second_driver"
                        type="checkbox"
                        value="true"
                        class="focus:ring-primary h-4 w-4 text-primary border-primary border-opacity-30 rounded"
                    />
                </div>
                <div class="ml-3">
                    <label
                        for="second_driver"
                        class="font-medium text-primary-text"
                    >
                        Einen weiteren Fahrer angeben
                    </label>
                </div>
            </div>
        </div>

        <div
            class="grid sm:grid-cols-2 gap-x-10 gap-y-5 sm:space-y-0"
            v-if="form.second_driver"
        >
            <div>
                <label for="firstname" class="block text-primary-text">
                    Vorname
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].firstname"
                        name="drivers[][firstname]"
                        id="firstname"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.firstname'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.firstname']"
                >
                    <strong>{{ form.errors["drivers.0.firstname"] }}</strong>
                </small>
            </div>

            <div>
                <label for="lastname" class="block text-primary-text">
                    Nachname
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].lastname"
                        name="drivers[][lastname]"
                        id="lastname"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.lastname'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.lastname']"
                >
                    <strong>{{ form.errors["drivers.0.lastname"] }}</strong>
                </small>
            </div>

            <div>
                <label for="street" class="block text-primary-text">
                    Straße und Hausnummer
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].street"
                        name="drivers[][street]"
                        id="street"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.street'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.street']"
                >
                    <strong>{{ form.errors["drivers.0.street"] }}</strong>
                </small>
            </div>

            <div>
                <label for="zip" class="block text-primary-text"> PLZ </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].zip"
                        name="drivers[][zip]"
                        id="zip"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors['drivers.0.zip'],
                            },
                        ]"
                    />
                </div>
                <small class="text-red-500" v-if="form.errors['drivers.0.zip']">
                    <strong>{{ form.errors["drivers.0.zip"] }}</strong>
                </small>
            </div>

            <div>
                <label for="city" class="block text-primary-text">
                    Stadt
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].city"
                        name="drivers[][city]"
                        id="city"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500': form.errors['drivers.0.city'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.city']"
                >
                    <strong>{{ form.errors["drivers.0.city"] }}</strong>
                </small>
            </div>

            <div>
                <label for="phone" class="block text-primary-text">
                    Telefon
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].phone"
                        name="drivers[][phone]"
                        id="phone"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.phone'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.phone']"
                >
                    <strong>{{ form.errors["drivers.0.phone"] }}</strong>
                </small>
            </div>

            <div>
                <label for="date_of_birth" class="block text-primary-text">
                    Geburtsdatum
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].date_of_birth"
                        name="drivers[][date_of_birth]"
                        id="date_of_birth"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.date_of_birth'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.date_of_birth']"
                >
                    <strong>{{
                        form.errors["drivers.0.date_of_birth"]
                    }}</strong>
                </small>
            </div>

            <div>
                <label for="place_of_birth" class="block text-primary-text">
                    Geburtsort
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].place_of_birth"
                        name="drivers[][place_of_birth]"
                        id="place_of_birth"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.place_of_birth'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.place_of_birth']"
                >
                    <strong>{{
                        form.errors["drivers.0.place_of_birth"]
                    }}</strong>
                </small>
            </div>

            <div>
                <label for="drivers_license_id" class="block text-primary-text">
                    Führerscheinnummer
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].drivers_license_id"
                        name="drivers[][drivers_license_id]"
                        id="drivers_license_id"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.drivers_license_id'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.drivers_license_id']"
                >
                    <strong>{{
                        form.errors["drivers.0.drivers_license_id"]
                    }}</strong>
                </small>
            </div>

            <div>
                <label for="identity_card_id" class="block text-primary-text">
                    Ausweisnummer
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        type="text"
                        v-model="form.drivers[0].identity_card_id"
                        name="drivers[][identity_card_id]"
                        id="identity_card_id"
                        :class="[
                            'block w-full rounded-md border-primary border-opacity-30',
                            {
                                'border-red-500':
                                    form.errors['drivers.0.identity_card_id'],
                            },
                        ]"
                    />
                </div>
                <small
                    class="text-red-500"
                    v-if="form.errors['drivers.0.identity_card_id']"
                >
                    <strong>{{
                        form.errors["drivers.0.identity_card_id"]
                    }}</strong>
                </small>
            </div>
        </div>

        <div class="mt-10 mb-3 font-semibold text-xl text-primary-text">
            Angaben zur Bezahlung
        </div>

        <RadioGroup v-model="form.initial_payment_method">
            <div
                class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4"
            >
                <RadioGroupOption
                    v-if="!booking.created_by_admin"
                    as="template"
                    value="total"
                    v-slot="{ checked, active }"
                >
                    <div
                        :class="[
                            checked
                                ? 'border-transparent'
                                : 'border-primary border-opacity-30',
                            active ? 'border-primary ring-2 ring-primary' : '',
                            'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none',
                        ]"
                    >
                        <span class="flex-1 flex">
                            <span class="flex flex-col">
                                <RadioGroupLabel
                                    as="span"
                                    class="block font-medium text-primary-text"
                                >
                                    Ich möchte den
                                    <span class="font-semibold"
                                        >Gesamtbetrag</span
                                    >
                                    bezahlen und die Reservierung vornehmen.
                                </RadioGroupLabel>
                                <RadioGroupDescription
                                    as="span"
                                    class="mt-6 font-bold text-primary"
                                >
                                    Gesamtbetrag:
                                    {{
                                        new Intl.NumberFormat("de-DE", {
                                            style: "currency",
                                            currency: "EUR",
                                        }).format(booking.total_price)
                                    }}
                                </RadioGroupDescription>
                            </span>
                        </span>
                        <CheckCircleIcon
                            :class="[
                                !checked ? 'invisible' : '',
                                'h-7 w-7 text-primary',
                            ]"
                            aria-hidden="true"
                        />
                        <span
                            :class="[
                                active ? 'border' : 'border-2',
                                checked
                                    ? 'border-primary'
                                    : 'border-transparent',
                                'absolute -inset-px rounded-lg pointer-events-none',
                            ]"
                            aria-hidden="true"
                        />
                    </div>
                </RadioGroupOption>

                <RadioGroupOption
                    v-if="!booking.created_by_admin"
                    as="template"
                    value="deposit"
                    v-slot="{ checked, active }"
                >
                    <div
                        :class="[
                            checked
                                ? 'border-transparent'
                                : 'border-primary border-opacity-30',
                            active ? 'border-primary ring-2 ring-primary' : '',
                            'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none',
                        ]"
                    >
                        <span class="flex-1 flex">
                            <span class="flex flex-col">
                                <RadioGroupLabel
                                    as="span"
                                    class="block font-medium text-primary-text"
                                >
                                    Ich möchte eine
                                    <span class="font-semibold">Anzahlung</span>
                                    leisten und die Reservierung vornehmen.
                                </RadioGroupLabel>
                                <RadioGroupDescription
                                    as="span"
                                    class="mt-6 font-bold text-primary"
                                >
                                    Anzahlung:
                                    {{
                                        new Intl.NumberFormat("de-DE", {
                                            style: "currency",
                                            currency: "EUR",
                                        }).format(booking.deposit_price)
                                    }}
                                </RadioGroupDescription>
                            </span>
                        </span>
                        <CheckCircleIcon
                            :class="[
                                !checked ? 'invisible' : '',
                                'h-7 w-7 text-primary',
                            ]"
                            aria-hidden="true"
                        />
                        <span
                            :class="[
                                active ? 'border' : 'border-2',
                                checked
                                    ? 'border-primary'
                                    : 'border-transparent',
                                'absolute -inset-px rounded-lg pointer-events-none',
                            ]"
                            aria-hidden="true"
                        />
                    </div>
                </RadioGroupOption>

                <RadioGroupOption
                    v-if="booking.created_by_admin"
                    as="template"
                    value="cash"
                    v-slot="{ checked, active }"
                >
                    <div
                        :class="[
                            checked
                                ? 'border-transparent'
                                : 'border-primary border-opacity-30',
                            active ? 'border-primary ring-2 ring-primary' : '',
                            'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none',
                        ]"
                    >
                        <span class="flex-1 flex">
                            <span class="flex flex-col">
                                <RadioGroupLabel
                                    as="span"
                                    class="block font-medium text-primary-text"
                                >
                                    Der Kunde wird den <br />Gesamtbetrag in
                                    <span class="font-semibold">bar</span>
                                    zahlen.
                                </RadioGroupLabel>
                                <RadioGroupDescription
                                    as="span"
                                    class="mt-6 font-bold text-primary"
                                >
                                    Gesamtbetrag:
                                    {{
                                        new Intl.NumberFormat("de-DE", {
                                            style: "currency",
                                            currency: "EUR",
                                        }).format(booking.total_price)
                                    }}
                                </RadioGroupDescription>
                            </span>
                        </span>
                        <CheckCircleIcon
                            :class="[
                                !checked ? 'invisible' : '',
                                'h-7 w-7 text-primary',
                            ]"
                            aria-hidden="true"
                        />
                        <span
                            :class="[
                                active ? 'border' : 'border-2',
                                checked
                                    ? 'border-primary'
                                    : 'border-transparent',
                                'absolute -inset-px rounded-lg pointer-events-none',
                            ]"
                            aria-hidden="true"
                        />
                    </div>
                </RadioGroupOption>
            </div>
        </RadioGroup>

        <div class="mt-5 flex justify-end">
            <button type="submit">
                <StyledButton background-primary>
                    <div class="flex items-center">
                        Weiter
                        <ArrowRightIcon class="h-5 w-5 ml-2" />
                    </div>
                </StyledButton>
            </button>
        </div>
    </form>
</template>

<script>
import { ArrowRightIcon } from "@heroicons/vue/outline";
import {
    RadioGroup,
    RadioGroupDescription,
    RadioGroupLabel,
    RadioGroupOption,
} from "@headlessui/vue";
import { CheckCircleIcon } from "@heroicons/vue/solid";
import StyledButton from "@/Components/StyledButton";
export default {
    components: {
        ArrowRightIcon,
        StyledButton,
        RadioGroup,
        RadioGroupDescription,
        RadioGroupLabel,
        RadioGroupOption,
        CheckCircleIcon,
    },

    props: {
        booking: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                company: this.booking?.company ?? "",
                firstname: this.booking?.firstname ?? "",
                lastname: this.booking?.lastname ?? "",
                street: this.booking?.street ?? "",
                zip: this.booking?.zip ?? "",
                city: this.booking?.city ?? "",
                email: this.booking?.email ?? "",
                phone: this.booking?.phone ?? "",
                date_of_birth: this.booking?.date_of_birth ?? "",
                place_of_birth: this.booking?.place_of_birth ?? "",
                drivers_license_id: this.booking?.drivers_license_id ?? "",
                identity_card_id: this.booking?.identity_card_id ?? "",
                drivers: this.booking?.drivers ?? { 0: {} },
                initial_payment_method: this.booking.created_by_admin
                    ? "cash"
                    : this.booking?.initial_payment_method ?? "total",
                second_driver: this.booking?.drivers?.firstname ? true : false,
            }),
        };
    },
};
</script>
